module.exports = __webpack_public_path__ + "img/img6.acb3b595.png";